import { Outlet } from 'react-router';

export const AnonymousFixedBroadbandOrderPathCoCo = () => <Outlet />;
